var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",class:_vm.bgSize,style:([_vm.getBgColor, _vm.getBorderColor])},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"color":_vm.color,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }